import { Box } from "@jewlr/storybook/core"
import { Helmet } from "react-helmet-async"

import Image from "components/landing/image"
import ImageBackgroundBanner from "components/landing/image-background-banner"

import {
  banner,
  featuringPremium,
  diamondBlock,
  moreToExplore,
  worryFree,
  giftPackage,
} from "./data"
import DiamondBlock from "./diamond-block"
import FeaturingDiamond from "./featuring-diamond"

const DiamondStudEarrings = () => (
  <Box textAlign="center">
    <Helmet>
      <title>Diamond Stud Earrings</title>
    </Helmet>
    <ImageBackgroundBanner element={banner()} firstElement />
    <FeaturingDiamond data={featuringPremium()} />
    {diamondBlock().map((diamond, i) => {
      const style_codes = diamond.details.map((item) => item.style_code)
      return (
        <DiamondBlock
          data={diamond}
          key={i}
          product_option="s1"
          style_codes={style_codes}
        />
      )
    })}
    <ImageBackgroundBanner element={moreToExplore()} />
    <Image image={worryFree()} />
    <ImageBackgroundBanner element={giftPackage()} />
  </Box>
)

export default DiamondStudEarrings
